import { useARC } from "providers/ARC/ARCContext";

type FleetControlSourceOptions = {
    fleetArcId?: string;
};

/**
 * Returns the selected fleet ARC ID for path-routed proxy requests. Direct
 * ARC mode has no fleetArcId and returns null.
 *
 * The marker is provider state, not a URL query parameter; control-source URL
 * construction receives the complete path separately.
 */
const useFleetArcId = (): string | null => {
    const arc = useARC();
    return (arc?.selectedARC?.controlSourceOptions as FleetControlSourceOptions)?.fleetArcId ?? null;
};

export default useFleetArcId;
